import { apiClient } from '@/lib/api/client';
import { API_ENDPOINTS } from '@/lib/api/config';
import type {
  Device,
  CreateDeviceRequest,
  UpdateDeviceRequest,
  DevicesListParams,
  DeviceMetrics
} from '../types';

const { DEVICES } = API_ENDPOINTS;

export const devicesApi = {
  getAll: (params?: DevicesListParams) =>
    apiClient.getPaginated<Device>(DEVICES.LIST, params),

  getById: (id: number) => apiClient.get<Device>(DEVICES.GET(id)),

  create: (data: CreateDeviceRequest) =>
    apiClient.post<Device>(DEVICES.CREATE, data),

  update: (id: number, data: UpdateDeviceRequest) =>
    apiClient.put<Device>(DEVICES.UPDATE(id), data),

  delete: (id: number) => apiClient.delete(DEVICES.DELETE(id)),

  bulkDelete: (
    params:
      | { ids: number[] }
      | { all: true; filters: Partial<DevicesListParams> }
  ) => apiClient.post(DEVICES.BULK_DELETE, params),

  metrics: () => apiClient.get<DeviceMetrics>(DEVICES.METRICS)
};
